<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.member_voucher_redeemed_log") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-12.mb-1
                DateRangePicker(:value="dateRange" @update="getData")
              .form-group.col-md-3.col-2.mb-1(v-if="!isOperator")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user-secret
                  DebounceInput(autofocus type="text" v-model="searchOperatorID" :placeholder="$t('ui.operator_id')" @enter="getLogList(true)" size="sm")
              .form-group.col-md-3.col-2.mb-1(v-if="searchOperatorID.length > 0")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user
                  DebounceInput(type="text" v-model="searchMemberID" :placeholder="$t('ui.member_id')" @enter="getLogList(true)" size="sm")
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getLogList(true)"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="10%")
                          span(:title="$t('ui.domain')") {{ $t('ui.domain') }}
                        th.text-center(width="10%")
                          span(:title="$t('ui.code')") {{ $t('ui.code') }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                        th.text-center(width="10%")
                          span(:title="$t('ui.ip_address')") {{ $t('ui.ip_address') }}
                        th.text-right(width="15%" @click="sortOrder('action_date')")
                          span(:title="$t('ui.action_date')") {{ $t('ui.action_date') }}
                          .float-right
                            i(:class="changeSortKey('action_date')")
                    tbody.clusterize-content
                      tr(v-if="logList.length == 0")
                        td(colspan="6").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in logList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.domain_name") {{ item.domain_name }}
                        td.text-center
                          span.font-weight-bold(:title="item.code") {{ item.code }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.amount)" :title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                        td.text-center
                          span(:title="item.ip_address") {{ item.ip_address }}
                        td.text-right
                          span.d-block(:title="item.action_by") {{ item.action_by }}
                          span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    logList: [],
    currentPage: 1,
    totalRow: 0,
    searchOperatorID: "",
    searchMemberID: "",
    dateRange: {
      startDate: null,
      endDate: null
    },
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "action_date",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    }
  },
  mounted() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');

    if (this.isOperator) {
      this.searchOperatorID = this.accountID;
      this.getLogList(true);
    }
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getLogList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortType == 'asc')
        return 'fa fa-sort-up';
      else
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      return this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') <= 31;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getLogList(true);
    },
    getLogList(isSearch) {
      if (!this.checkDateRange()) {
        this.totalRow = 0;
        this.logList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
        return;
      }

      if (isSearch) this.currentPage = 1;

      const json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.searchOperatorID,
        member_id: this.searchMemberID,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(config.memberVoucherRedeemedLogUrl(), json).then(
        function(response) {
          this.loading = false;
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success) {
                this.logList = response.data.dt;
                this.totalRow = this.logList.length > 0 ? this.logList[0].totalrows : 0;
              } else if (!this.$helpers.handleFeedback(this.feedback.status)) {
                this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getLogList(true);
    },
    changedPage(pageNo) {
      this.currentPage = pageNo;
      this.getLogList();
    }
  }
};
</script>
